module.exports = __webpack_public_path__ + "static/media/reactions.15804b89.svg";